module.exports = __webpack_public_path__ + "img/pause.675c2407.svg";